
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="800px"
      transition="dialog-transition"
    >
      <base-card with_divider>
        <template slot="title">
          <span class="text-capitalize">
            {{ $tc('stages.edit')}}
          </span>
        </template>

        <template v-slot:content>
          <v-form ref="stageForm">
            <v-text-field 
              :placeholder="$t('stages.name_form_label')"
              solo flat class="black--text" style="font-weight: 900; font-size: large !important;"
              v-model="local_stage.name" dense
              :rules="required"
            ></v-text-field>

            <v-row align="center" class="pa-3" v-if="false && max_positions > 1">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('position') }}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="local_stage.position"
                  :rules="[
                    ruleNumberEqualLessThan(max_positions),
                    ruleNumberEqualGreaterThan(1)
                  ]"
                  type="number" min="1"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{$t('stages.quantity_alterations')}}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="local_stage.qtd_alterations"
                  :rules="[ruleNumberEqualGreaterThan(0)]"
                  type="number" min="0"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row align="center" class="pa-3">
              <b class="subtitle-1 black--text mb-6 mr-2"> {{ $t('stages.expected_duration_form_label') }}: </b>
              <v-col cols="2" class="pa-0">
                <v-text-field filled rounded
                  class="rounder" dense
                  v-model="local_stage.default_duration_days"
                  :rules="[ruleNumberEqualGreaterThan(1)]"
                  type="number" min="1"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </template>

        <template slot="actions">
          <v-btn small color="error" class="font-weight-bold" @click="cancel" text>{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" class="font-weight-bold" @click="save" text>{{ $t('save') }}</v-btn>
        </template>

      </base-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'DialogOneStage',
  mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  props: {
    stage: {
      type: Object,
      // default: 
    },
    position: {
      type: [String, Number],
    },
    max_positions: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: true,
      local_stage: {},
    }
  },
  methods: {
    cancel(){
      this.$emit('cancel')
    },
    save(){
      if (this.$refs.stageForm.validate()){
        this.$emit('done', {...this.local_stage})
      }
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv == false){
        this.cancel()
      }
    }
  },
  mounted () {
    this.local_stage = {
      ...this.stage,
      ...this.stage.json_attributes,
    };
  },
}
</script>

<style scoped>

</style>